module.exports = __webpack_public_path__ + "img/mobile/SmartButton-promo/btn-spin@2x.png?1.0.17";